import React from 'react'
import { getElementId, useWebformElement } from '../utils'

import WebformElementWrapper from './webformElementWrapper'
import { Textarea } from "@rebass/forms";

export const WebformTextarea = ({ element, error, color }) => {
	const id = getElementId(element.name);
	const [inputProps, settings] = useWebformElement(element, {
		className: 'form-control',
		name: element.name,
		id,
	});

	return (
		<WebformElementWrapper settings={settings} error={error} labelFor={id} color={color} columns={1}>
			<Textarea rows={5} {...inputProps} />
		</WebformElementWrapper>
	)
};

export default WebformTextarea
